// src/locale/da.js
export default {
  dataIterator: {
    rowsPerPageText: "Rækker pr. side:",
    rowsPerPageAll: "Alle",
    pageText: "{0}-{1} af {2}",
    noResultsText: "Ingen matchende poster fundet",
    nextPage: "Næste side",
    prevPage: "Forrige side",
  },
  dataTable: {
    rowsPerPageText: "Rækker pr. side:",
  },
  noDataText: "Ingen data tilgængelig",
  carousel: {
    prev: "Forrige visning",
    next: "Næste visning",
    ariaLabel: {
      delimiter: "Karusel slide {0} af {1}",
    },
  },
  calendar: {
    moreEvents: "{0} mere",
  },
  fileInput: {
    counter: "{0} filer",
    counterSize: "{0} filer ({1} i alt)",
  },
};
